import { useEffect, useState } from 'react'
import { Modal, Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { postDiscussionModel } from '../../../actions/discussions/discussionmodelpost'
import { postDiscussion } from '../../../actions/discussions/discussionpost'
import { Button } from '../../../common/Button.tsx'
import { localDate } from '../../../common/utils'
import { DiscussionGroup1 } from './discussiongroup1'
import { DiscussionGroup2 } from './discussiongroup2'
import { DiscussionGroup3 } from './discussiongroup3'
import { DiscussionGroup4 } from './discussiongroup4'
import { DiscussionGroup5 } from './discussiongroup5'

export function DiscussionModalBody({ state, show, handleCancel, personId }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [discussion, setDiscussion] = useState({ ...state })
	useEffect(() => setDiscussion({ ...state }), [state])

	const handleChange = ({ target }) => {
		const currentDate = localDate()
		const id = target.id
		const value = target.type === 'checkbox' ? target.checked : target.value
		if (id === 'discussionDate' && value < currentDate && discussion.discussionStatus === 'OPEN') {
			setDiscussion((data) => {
				const newData = { ...data }
				newData[id] = value
				newData.discussionStatus = 'LATE'
				return newData
			})
		} else if (id === 'discussionDate' && value >= currentDate && discussion.discussionStatus === 'LATE') {
			setDiscussion((data) => {
				const newData = { ...data }
				newData[id] = value
				newData.discussionStatus = 'OPEN'
				return newData
			})
		} else {
			setDiscussion((data) => {
				const newData = { ...data }
				newData[id] = value
				return newData
			})
		}
	}

	function save() {
		const discussionData = { ...discussion }
		if (!discussionData.discussionStatus) {
			delete discussionData.discussionStatus
		}
		if (discussionData.personId > 0) {
			dispatch(postDiscussion(discussionData))
		} else {
			dispatch(postDiscussionModel(discussionData))
		}
	}

	const modalTitle =
		discussion.personId > 0
			? discussion.id > 0
				? `${t('Discussion', 'Keskustelu')} - ${discussion.discussionModel.discussionModelName}`
				: `${t('NewDiscussion', 'Uusi keskustelu')} - ${discussion.discussionModelName}`
			: discussion.id > 0
				? `${t('DiscussionModel', 'Keskustelumalli')} - ${discussion.discussionModelName}`
				: t('NewDiscussionModel', 'Uusi keskustelumalli')

	return (
		discussion && (
			<Modal show={show} onHide={handleCancel} backdrop="static" size="xl" fullscreen="lg-down" scrollable>
				<Modal.Header closeButton onHide={handleCancel}>
					<Modal.Title>{modalTitle}</Modal.Title>
				</Modal.Header>
				<Modal.Body className="d-flex flex-column heeros-background p-0">
					<Tabs defaultActiveKey="discussion" className="scrollable mb-3">
						<Tab eventKey="discussion" title={t('Discussion', 'Keskustelu')}>
							<DiscussionGroup1 handleChange={handleChange} setDiscussion={setDiscussion} state={discussion} />
						</Tab>
						{discussion.discussionModelName !== '' && (
							<Tab eventKey="notePad" title={t('NotePad', 'Muistio')}>
								<DiscussionGroup2 handleChange={handleChange} state={discussion} />
							</Tab>
						)}
						{discussion.discussionModelName !== '' && (
							<Tab eventKey="tasksAndGoals" title={t('TasksAndGoals', 'Tehtävät & tavoitteet')}>
								<DiscussionGroup3
									handleChange={handleChange}
									setDiscussion={setDiscussion}
									state={discussion}
									personId={personId}
								/>
							</Tab>
						)}
						{discussion.discussionModelName !== '' && discussion.discussionConfidential !== '!N/A!' && (
							<Tab eventKey="confidentialInfo" title={t('ConfidentialInfo', 'Luottamukselliset asiat')}>
								<DiscussionGroup4 handleChange={handleChange} state={discussion} />
							</Tab>
						)}
						{discussion.discussionModelName !== '' && (
							<Tab eventKey="attachments" title={t('Attachments', 'Liitteet')}>
								<DiscussionGroup5 handleChange={handleChange} state={discussion} />
							</Tab>
						)}
					</Tabs>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						onClick={save}
						disabled={discussion.id === 0 && discussion.discussionModelName === ''}
					>
						{`${t('Save', 'Tallenna')} ${discussion.personId > 0 ? t('Discussion', 'Keskustelu') : t('DiscussionModel', 'Malli')}`}
					</Button>
				</Modal.Footer>
			</Modal>
		)
	)
}
